import React from "react";
import { connect } from "react-redux";
import * as userActions from "../../actions/users";
import * as catalogActions from "../../actions/catalogs";
import BasicDataUserForm from "../../components/basicDataUserForm";
import { withRouter } from "react-router-dom";
import { getPositions } from "../../actions/catalogs";

interface Props {
  match: any;
  saveBasicUser: (user: object) => any;
  updateBasicUser: (personaId: string, user: object) => any;
  successfulSave: boolean;
  getBasicUser: (id: string) => any;
  user: object;
  onClickSave: (f: any) => any;
  onSuccessfulSave: () => any;
  domains: object[];
  getDomains: () => any;
  gettingUserById: boolean;
  clearBasicUser: () => any;

  // Catálogo de puestos de trabajo
  getPositions: () => any;
  positions: any;

  // Correo de empleado
  verificarCorreoEmpleado: (correo: string, numeroEmpleado: string) => any;
  actualizarCorreoEmpleado: (idUser: number, nuevoCorreo: string) => any;
  eliminarCorreoPorCorreo: (correo: string) => any;
  correoDiagnostico: any;
  actualizandoCorreo: boolean;
  correoActualizado: boolean;
  eliminandoCorreo: boolean;
  correoEliminado: boolean;
}

class BasicDataUserContainer extends React.Component<Props, void> {
  componentDidMount() {
    this.props.getDomains();
    this.props.getPositions();
    if (!this.props.match.params.personaId) {
      this.props.clearBasicUser();
    }
  }

  render() {
    return (
      <BasicDataUserForm
        saveBasicUser={this.props.saveBasicUser}
        user={this.props.user}
        updateBasicUser={this.props.updateBasicUser}
        onClickSave={this.props.onClickSave}
        getBasicUser={this.props.getBasicUser}
        domains={this.props.domains}
        gettingUserById={this.props.gettingUserById}
        positions={this.props.positions}
        verificarCorreoEmpleado={this.props.verificarCorreoEmpleado}
        actualizarCorreoEmpleado={this.props.actualizarCorreoEmpleado}
        correoDiagnostico={this.props.correoDiagnostico}
        actualizandoCorreo={this.props.actualizandoCorreo}
        correoActualizado={this.props.correoActualizado}
        eliminarCorreoPorCorreo={this.props.eliminarCorreoPorCorreo}
        eliminandoCorreo={this.props.eliminandoCorreo}
        correoEliminado={this.props.correoEliminado}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  saveBasicUser: (user: object) => {
    return dispatch(userActions.saveBasicUser(user));
  },
  getBasicUser: (id: string) => {
    dispatch(userActions.getUserById(id));
  },
  updateBasicUser: (personaId: string, user: object) => {
    dispatch(userActions.updateBasicUser(personaId, user));
  },
  getDomains: () => {
    dispatch(catalogActions.getDomains());
  },
  clearBasicUser: () => {
    dispatch(userActions.clearBasicUser());
  },
  getPositions: () => {
    dispatch(getPositions());
  },
  verificarCorreoEmpleado: (correo: string, numeroEmpleado: string) => {
    return dispatch(
      userActions.verificarCorreoEmpleado(correo, numeroEmpleado)
    );
  },
  actualizarCorreoEmpleado: (idUser: number, nuevoCorreo: string) => {
    return dispatch(userActions.actualizarCorreoEmpleado(idUser, nuevoCorreo));
  },
  eliminarCorreoPorCorreo: (correo: string) => {
    return dispatch(userActions.eliminarCorreoPorCorreo(correo));
  }
});

const mapStateToProps = state => {
  const { user, catalogs } = state;
  return {
    user: user.userById,
    gettingUserById: user.gettingBasicUser,
    domains: catalogs.domains ? catalogs.domains : [],
    positions: catalogs.catalogPostions,
    correoDiagnostico: user.correoDiagnostico,
    actualizandoCorreo: user.actualizandoCorreo,
    correoActualizado: user.correoActualizado,
    eliminandoCorreo: user.eliminandoCorreo,
    correoEliminado: user.correoEliminado
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BasicDataUserContainer)
);
